var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Twitch = youbora.Adapter.extend({

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.getCurrentTime()
  },

  /** Override to return Frames Per Second (FPS) */
  getFramesPerSecond: function () {
    return this.player.getPlaybackStats().fps
  },

  getPlayrate: function () {
    var ret = 1
    if (!this.getIsLive()) {
      var quality = this.player.getQuality()
      var qualities = this.player.getQualities()
      for (var level in qualities) {
        var qualityLevel = qualities[level]
        if (qualityLevel.group === quality) {
          ret = this.player.getPlaybackStats().fps / qualityLevel.framerate
        }
      }
    }
    return ret
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    return this.player.getPlaybackStats().skippedFrames
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.getDuration()
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    var bitrate = -1
    var quality = this.player.getQuality()
    var qualities = this.player.getQualities()
    for (var level in qualities) {
      if (qualities[level].group === quality) {
        bitrate = qualities[level].bitrate
      }
    }
    return bitrate
  },

  /** Override to return rendition */
  getRendition: function () {
    var rendition = null
    var quality = this.player.getQuality()
    var qualities = this.player.getQualities()
    for (var level in qualities) {
      var qualityLevel = qualities[level]
      if (qualityLevel.group === quality) {
        rendition = youbora.Util.buildRenditionString(qualityLevel.width, qualityLevel.height, qualityLevel.bitrate)
      }
    }
    // For rendition changes, codec may change too
    if (this.player.getPlaybackStats() && this.player.getPlaybackStats().codecs) {
      var codec = this.player.getPlaybackStats().codecs
      var video = codec.substring(0, codec.indexOf(','))
      this.plugin.options['content.encoding.videoCodec'] = video.substring(0, video.indexOf('.'))
      this.plugin.options['content.encoding.codecSettings'] = video.substring(video.indexOf('.') + 1)
      this.plugin.options['content.encoding.audioCodec'] = codec.substring(codec.indexOf(',') + 1)
    }
    return rendition
  },

  /** Override to return title */
  getTitle: function () {
    return this.player.getChannel() || this.player.getVideo()
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.player.getDuration() === Infinity
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'Twitch'
  },

  /** Override to return the video latency */
  getLatency: function () {
    return this.getIsLive() ? this.player.getPlaybackStats().hlsLatencyBroadcaster : null
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, true)

    // References
    this.references = []
    this.references['play'] = this.playListener.bind(this)
    this.references['pause'] = this.pauseListener.bind(this)
    this.references['playing'] = this.playingListener.bind(this)
    this.references['ended'] = this.endedListener.bind(this)

    // Register listeners
    for (var key in this.references) {
      this.player.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) {
    this.fireStart()
    this.fireResume()
    this.fireJoin()
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
  }
})

module.exports = youbora.adapters.Twitch
